// extracted by mini-css-extract-plugin
export default {"link":"Link_link__haM9E","active":"Link_active__1LsFm"};